import React, { useCallback } from 'react';
import Slider from 'react-slick';
import { galleryStore } from '../store';
import { isMp4, classNames } from '../tools/helpers';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function GallerySlider({ images }) {
    const setDialogGallerySlider = (state) => {
        galleryStore.setState((prevState) => ({
            ...prevState,
            ...state,
        }));
    };

    const ResponsiveSquareImage = useCallback(
        ({ src, alt }) => (
            <div className="aspect-square overflow-hidden relative">
                {isMp4(src) ? (
                    <video
                        autoPlay
                        muted
                        loop
                        controls={false}
                        className="w-full h-full object-cover"
                    >
                        <source src={src} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <img
                        src={src}
                        alt={alt}
                        className="w-full h-full object-cover"
                    />
                )}
            </div>
        ),
        [],
    );

    const ImageSlide = useCallback(
        ({ image, index }) => (
            <div
                className={'relative group'}
                role="button"
                tabIndex={0}
                onClick={() =>
                    setDialogGallerySlider({
                        open: true,
                        imageActive: index,
                        images,
                    })
                }
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        setDialogGallerySlider({
                            open: true,
                            imageActive: index,
                            images,
                        });
                    }
                }}
            >
                <ResponsiveSquareImage src={image} alt={image} />
                <p
                    className={classNames(
                        'relative focus:outline-none focus:ring-0 focus:ring-offset-0',
                        'bg-white text-apart-black-100 rounded-lg px-6 min-h-10 text-base font-bold',
                        'hidden sm:flex items-center justify-center',
                        '!absolute transition-all opacity-0 group-hover:!opacity-100 top-1/2 right-1/2 transform translate-x-1/2 -translate-y-1/2 z-0',
                    )}
                >
                    View
                </p>
            </div>
        ),
        [],
    );

    const settings = {
        className: 'relative',
        dots: true,
        dotsClass:
            '!hidden sm:!flex absolute left-1/2 transform -translate-x-1/2 apart-dots w-[calc(50%-16px)] sm:w-[calc(50%-40px)] text-center items-center justify-center -mt-5 h-2 gap-2',
        autoplay: false,
        autoplaySpeed: 10000,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className={'overflow-hidden rounded-[20px]'}>
            {images.length > 1 && (
                <Slider {...settings}>
                    {images.map((image, index) => (
                        <ImageSlide key={index} image={image} index={index} />
                    ))}
                </Slider>
            )}
            {images.length === 1 && <ImageSlide image={images[0]} />}
        </div>
    );
}
